var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArowCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 10.828L7.05026 15.778L5.63626 14.364L12.0003 8L18.3643 14.364L16.9503 15.778L12.0003 10.828Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArowCollapse);
export default __webpack_public_path__ + "static/media/icon_arow_collapse.18b3f5b08329e8426074065a2bb0bc83.svg";
export { ForwardRef as ReactComponent };